import { fetchSurveys } from 'client/modules/Surveys/SurveyActions';
import { getSurveys } from 'client/modules/Surveys/SurveyReducer';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { getProfile, isLoggedIn } from './modules/Auth/AuthReducer';
import HomePage from './modules/Public/pages/HomePage/HomePageContainer';
import ChooseTypePage from './modules/Surveys/pages/ChooseTypePage/ChooseTypePage';

function AuthenticatedHome() {
  const surveys = useSelector(getSurveys);
  const loggedIn = useSelector(isLoggedIn);
  const emailVerified = useSelector(getProfile)?.email_verified;
  const dispatch = useDispatch();

  useEffect(() => {
    if (loggedIn && emailVerified && !surveys) {
      dispatch(fetchSurveys());
    }
  }, [loggedIn, emailVerified, surveys, dispatch]);

  if (!loggedIn) {
    return <HomePage />;
  }

  if (!emailVerified) {
    return <HomePage />;
  }

  if (!surveys) {
    return null;
  }

  if (surveys.length > 1) {
    return <Navigate to="/surveys/list/active" />;
  }
  if (surveys.length === 1) {
    return <Navigate to={`/surveys/${surveys[0].id}`} />;
  }
  return <ChooseTypePage />;
}

AuthenticatedHome.loader =
  ({ getState, dispatch }) =>
  () => {
    const state = getState();
    const loggedIn = isLoggedIn(state);
    if (loggedIn) {
      return dispatch(fetchSurveys());
    }
    return null;
  };

export default AuthenticatedHome;
